import { memo, useContext, useEffect, useState } from 'react';

import { Dialog } from './style';

import { getMarketAlertSearch } from '@/apis/activity';
import GroupSendCoupon from '@/components/GroupSendCoupon';
import NewCustomerPop from '@/components/NewCustomerPop';
import { LayoutContext } from '@/layouts/baseLayout/provider';
import { buriedPoint } from '@/utils/buriedPoint';

const TypeMap = {
  newcustomer: 'newcustomer', // 新人福利
  group: 'group', // 用户分群
};
const MarketAlertDialog = () => {
  const { resourceData } = useContext(LayoutContext);

  const [newCustomerDatas, setNewCustomerDatas] = useState(null); // 新人福利弹窗
  const [groupSendCoupons, setGroupSendCoupons] = useState(null); // 分群福利弹窗
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    handleGetMarketAlertSearch();
  }, []);

  const handleGetMarketAlertSearch = async () => {
    const res = await getMarketAlertSearch();
    if (res?.code !== 200 || !res?.msg) return false;
    const fn = {
      [TypeMap.newcustomer]: setNewCustomerDatas,
      [TypeMap.group]: setGroupSendCoupons,
    }[res?.msg];
    fn(res?.result);
    setIsOpen(true);
    if (res?.msg === TypeMap.group) {
      buriedPoint({
        ty: 'view',
        cp: 'float_adv',
        op: 'window_in_central',
        pf: 'pc',
        data: {
          Based_id: res?.result?.autoSubgroupId,
          hf: resourceData?.projectConfigVO?.lcscMemberUrl + '/member/couponList.html',
        },
      });
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isOpen]);

  const toggleModal = () => {
    setIsOpen(false);
  };

  return (
    isOpen && (
      <Dialog className={'fixed bottom-0 left-0 right-0 top-0 z-[1001] overflow-visible bg-[rgba(0,0,0,0.35)]'}>
        {newCustomerDatas && (
          <NewCustomerPop
            data={newCustomerDatas}
            targetLink={resourceData?.projectConfigVO?.lcscActivityUrl + '/newuser.html'}
            onClose={toggleModal}
          ></NewCustomerPop>
        )}
        {groupSendCoupons && (
          <GroupSendCoupon
            data={groupSendCoupons}
            targetLink={resourceData?.projectConfigVO?.lcscMemberUrl + '/member/couponList.html'}
            onClose={toggleModal}
          ></GroupSendCoupon>
        )}
      </Dialog>
    )
  );
};

export default memo(MarketAlertDialog);
